var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transfer-page',{ref:"transfer_page",attrs:{"configs":_vm.configs}},[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.$t("funds.balances.transfer")))]),_c('template',{slot:"actions"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }